// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0da7ee04","941":"3ed971df"}[chunkId] + ".chunk.js";
};